import { format, subYears } from "date-fns";
import { useMediaQuery } from "react-responsive";

const FiltroEventos = ({
  setFilter,
  filter,
  fetch,
  onClick,
  onChange,
  provincias,
  categorias,
  setData,
  salas,
  setSalas,
  setLoading,
  loading,
  user,
  anterior,
  setAnterior,
}) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });

  return (
    <div className="">
      <div
        className="row mb-4"
        style={{
          marginLeft: isDesktop ? "10vw" : "0px",
          marginRight: isDesktop ? "10vw" : "0px",
        }}
      >
        <div className="col-md-6">
          <h1 className="h2 fw-bold">EVENTOS</h1>
        </div>
        <div className="col-md-6 text-md-end">
          <button
            className="btn btn-custom-naranja text-white"
            name="añadir-evento"
            onClick={(event) => onClick(event)}
          >
            <i className="bi bi-plus me-2"></i>NUEVO EVENTO
          </button>
        </div>
      </div>

      <div
        className="card mb-4"
        style={{
          marginLeft: isDesktop ? "10vw" : "0px",
          marginRight: isDesktop ? "10vw" : "0px",
        }}
      >
        <div className="card-body">
          <div className="row g-3 mb-3">
            <div className={`col-md-3`}>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder="Buscar"
                  onChange={(e) => onChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      onClick({ target: { name: "search" } });
                  }}
                />
              </div>
            </div>
            <div
              className={`col-md-3 ${user?.roles[0].nombre == "adm" ? "" : "d-none"
                }`}
            >
              <select
                className="form-select"
                onChange={(e) => {
                  setLoading(true);
                  if (e.target.value == "todos") {
                    let params = filter;
                    delete params["filter[provincia]"];
                    setFilter({ ...params });
                    return fetch(setData, params, "/eventos");
                  }

                  setLoading(true);
                  setFilter({
                    ...filter,
                    ["filter[provincia]"]: e.target.value,
                  });
                  let params = {
                    ...filter,
                    ["filter[provincia]"]: e.target.value,
                  };

                  fetch(setData, params, "/eventos", null, setLoading);
                  fetch(
                    setSalas,
                    { ["filter[provincia]"]: e.target.value },
                    "/salas"
                  );
                }}
              >
                {"filter[provincia]" in filter && provincias.length > 0 ? (
                  <option selected>
                    {
                      provincias.filter(
                        (p) => p.provincia == filter["filter[provincia]"]
                      )[0].provincia
                    }
                  </option>
                ) : (
                  <option selected>Seleccionar provincia</option>
                )}

                {[...provincias, { provincia: "todos", total_eventos: "" }].map(
                  (provincia) => {
                    if ("filter[provincia]" in filter) {
                      if (filter["filter[provincia]"] == provincia.provincia) {
                        return "";
                      }
                    }
                    return (
                      <option
                        value={provincia.provincia}
                      >{`${provincia.provincia} (${provincia.total_eventos})`}</option>
                    );
                  }
                )}
              </select>
            </div>
            <div
              className={`col-md-3 ${user?.roles[0].nombre == "adm" ? "" : "d-none"
                }`}
            >
              <select
                className="form-select"
                onChange={(e) => {
                  setLoading(true);
                  if (e.target.value == "todos") {
                    let params = filter;
                    delete params["filter[nombre_sitio]"];
                    setFilter({ ...params });
                    return fetch(setData, params, "/eventos");
                  }

                  setFilter({
                    ...filter,
                    ["filter[nombre_sitio]"]: e.target.value,
                  });
                  let params = {
                    ...filter,
                    ["filter[nombre_sitio]"]: e.target.value,
                  };
                  fetch(setData, params, "/eventos");
                }}
              >
                {"filter[nombre_sitio]" in filter ? (
                  <option selected>
                    {
                      salas.data.filter(
                        (c) => c.nombre == filter["filter[nombre_sitio]"]
                      )[0].nombre
                    }
                  </option>
                ) : (
                  <option selected>Seleccionar sala</option>
                )}
                {[...salas.data, { nombre: "todos" }].map((sala) => {
                  if ("filter[nombre_sitio]" in filter) {
                    if (filter["filter[nombre_sitio]"] == sala.nombre) {
                      return "";
                    }
                  }
                  return (
                    <option value={sala.nombre}>{`${sala.nombre}`}</option>
                  );
                })}
              </select>
            </div>

            <div
              className={`col-md-3 ${user?.roles[0].nombre == "adm" ? "" : "d-none"
                }`}
            >
              <select
                className="form-select"
                onChange={(e) => {
                  setLoading(true);

                  if (e.target.value == "todos") {
                    let params = filter;
                    delete params["filter[category]"];
                    setFilter({ ...params });
                    return fetch(setData, params, "/eventos");
                  }
                  setFilter({
                    ...filter,
                    ["filter[category]"]: e.target.value,
                  });
                  let params = {
                    ...filter,
                    ["filter[category]"]: e.target.value,
                  };
                  fetch(setData, params, "/eventos");
                }}
              >
                {"filter[category]" in filter ? (
                  <option selected>
                    {
                      categorias.filter(
                        (c) => c.id == filter["filter[category]"]
                      )[0].nombre
                    }
                  </option>
                ) : (
                  <option selected>Seleccionar categoria</option>
                )}
                {[...categorias, { id: "todos", nombre: "TODOS" }].map(
                  (categoria) => {
                    if ("filter[category]" in filter) {
                      if (filter["filter[category]"] == categoria.id) {
                        return "";
                      }
                    }
                    return (
                      <option value={categoria.id}>{categoria.nombre}</option>
                    );
                  }
                )}
              </select>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">Desde</label>
              <input
                type="date"
                className="form-control"
                defaultValue={filter["filter[fecha]"].split(",")[0]}
                value={filter["filter[fecha]"].split(",")[0]}
                onChange={(e) => {
                  setLoading(true);
                  let hasta = filter.hasOwnProperty("filter[fecha]")
                    ? filter["filter[fecha]"].split(",")[1]
                    : format(new Date(), "yyyy-MM-dd").toString();

                  let params = {
                    ...filter,
                    ["filter[fecha]"]: `${e.target.value},${hasta}`,
                  };

                  setFilter({ ...params });
                  return fetch(setData, params, "/eventos");
                }}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold">Hasta</label>
              <input
                type="date"
                className="form-control"
                defaultValue={filter["filter[fecha]"].split(",")[1]}
                value={filter["filter[fecha]"].split(",")[1]}
                onChange={(e) => {
                  setLoading(true);
                  let desde = filter.hasOwnProperty("filter[fecha]")
                    ? filter["filter[fecha]"].split(",")[0]
                    : format(new Date(), "yyyy-MM-dd").toString();

                  let params = {
                    ...filter,
                    ["filter[fecha]"]: `${desde},${e.target.value}`,
                  };

                  setFilter({ ...params });
                  return fetch(setData, params, "/eventos");
                }}
              />
            </div>
            <div
              className={`col-md-4`}
            >
              <label className="form-label fw-semibold">Estado</label>
              <select
                className="form-select"
                onChange={(e) => {
                  if (e.target.value == "todos") {
                    let params = filter;
                    delete params["status"];
                    setFilter({ ...params });
                    return fetch(setData, params, "/eventos");
                  }
                  setFilter({ ...filter, status: e.target.value });
                  let params = { ...filter, status: e.target.value };
                  fetch(setData, params, "/eventos");
                }}
              >
                {"status" in filter ? (
                  <option selected>
                    {
                      [
                        { value: "Todos", label: "Todos" },
                        { value: "1", label: "Activo" },
                        { value: "2", label: "Pausado" },
                        { value: "3", label: "Eliminado" },
                        { value: "4", label: "Borrador" },
                      ].filter((c) => c.value == filter.status)[0].label
                    }
                  </option>
                ) : (
                  <option selected>Seleccionar estado</option>
                )}

                {[
                  { value: "Todos", label: "Todos" },
                  { value: "1", label: "Activo" },
                  { value: "2", label: "Pausado" },
                  { value: "3", label: "Eliminado" },
                  { value: "4", label: "Borrador" },
                ].map((status) => {
                  if ("status" in filter) {
                    if (filter.status == status.value) {
                      return "";
                    }
                  }
                  return <option value={status.value}>{status.label}</option>;
                })}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div
        className="d-flex mb-2"
        style={{
          borderRadius: "0.3rem",
          marginLeft: isDesktop ? "10vw" : "0px",
          marginRight: isDesktop ? "10vw" : "0px",
          backgroundColor: "#eaeaea",
        }}
      >
        <div className="p-2 w-100">
          <label
            className="btn btn-light border-0 w-100 "
            style={{
              backgroundColor: anterior ? "" : "#eaeaea",
              color: anterior ? "" : "#ccced1",
            }}
          >
            Eventos anteriores
            <button
              className="d-none"
              type="button"
              role="tab"
              onClick={(e) => {
                setLoading(true);
                let desde = format(
                  subYears(new Date(), 1),
                  "yyyy-MM-dd"
                );
                let hasta = format(new Date(), "yyyy-MM-dd").toString();

                let params = {
                  ...filter,
                  ["filter[fecha]"]: `${desde},${hasta}`,
                };

                setAnterior(true);
                setFilter({ ...params });
                return fetch(setData, params, "/eventos");
              }}
            ></button>
          </label>
        </div>
        <div className="p-2 w-100">
          <label
            className="btn btn-light  border-0 w-100"
            style={{
              backgroundColor: anterior ? "#eaeaea" : "",
              color: anterior ? "#ccced1" : "",
            }}
          >
            Eventos próximos
            <button
              className="d-none"
              type="button"
              role="tab"
              onClick={(e) => {
                setLoading(true);
                let desde = format(new Date(), "yyyy-MM-dd").toString();

                let params = {
                  ...filter,
                  ["filter[fecha]"]: `${desde}`,
                };

                setAnterior(false);
                setFilter({ ...params });
                return fetch(setData, params, "/eventos");
              }}
            ></button>
          </label>
        </div>
      </div>
    </div>
  );
};

export default FiltroEventos;
